export const magicStars = {
  "magic-stars": {
    shape:
      '<path fill="#fff" d="m10.8 17.925-2.1-4.65-4.65-2.125 4.65-2.1 2.1-4.675 2.125 4.675 4.65 2.1-4.65 2.125-2.125 4.65Zm6.775 1.7-1.05-2.325-2.325-1.075 2.325-1.05 1.05-2.325 1.05 2.325 2.325 1.05-2.325 1.075-1.05 2.325Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
